export default {
    id: null,
    status: "",
    name: "",
    description: "",
};
